export function Footer() {
  return (
    <footer className="border-t border-border mt-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6 py-8 text-sm text-foreground/60 flex flex-col md:flex-row items-center justify-between gap-4">
        <p>© {new Date().getFullYear()} Jenn Mueng. All rights reserved.</p>
        <p className="text-foreground/50">Built with love for clean, accessible design.</p>
      </div>
    </footer>
  );
}
